import { Injectable } from '@angular/core';
import { ConnectionService } from '../../../services/connection/connection.service';
import { interval, Subject } from 'rxjs';
import { VuConnectionHttpService } from './vu-connection-http.service';
import { startWith, switchMap, tap } from 'rxjs/operators';
import { VuState } from '../models/vu-state';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { ScanCard } from '../models/scan-card';
import { PartnerCodeStateService } from '../../partner-code/services/partner-code-state.service';
import { ShopSettingsService } from '../../general/services/shop-settings.service';
import { ScreenSaverService } from './screen-saver.service';

@Injectable()
export class VuCommunicationService {

  private _initialized = false;
  private _lastScanCard: ScanCard;
  readonly timeout = 3 * 1000;
  scanCardCodeEvent = new Subject<ScanCard>();

  constructor(
    private connectionService: ConnectionService,
    private vuConnectionHttpService: VuConnectionHttpService,
    private router: Router,
    private partnerCodeStateService: PartnerCodeStateService,
    private shopSettingsService: ShopSettingsService,
    private screenSaverService: ScreenSaverService,
  ) {
  }

  public initialize(): void {

    if (this._initialized) {
      return;
    }

    this._initialized = true;

    interval(this.timeout)
      .pipe(
        startWith(0),
        tap(() => {
          this.vuConnectionHttpService.vuBaseUrl = this.shopSettingsService.vuBaseUrl;
        }),
        switchMap(() => this.vuConnectionHttpService.pingAndGetVuState()),
      )
      .subscribe(
        (vuState: VuState) => {
          if (!vuState || !vuState.isValid) {
            this._redirectToLoadingUrl();
            return;
          }
          if (vuState.scanCard) {
            this._sendEventCard(vuState.scanCard);
          }

          this._odooTokenChanged(vuState.token);
          this.shopSettingsService.shopType = vuState.shopType;
          this.updateScreenSaverConfiguration();
        },
        error => this._redirectToLoadingUrl()
      );
  }

  updateScreenSaverConfiguration(): void {
    this.screenSaverService.updateConfiguration();
  }

  _redirectToLoadingUrl(): void {
    window.location.href = `/website_shop_angular/static/assets/html/vu.html?url=${this.shopSettingsService.vuBaseUrl}`;
  }

  private _odooTokenChanged(token: string): void {
    if (this.partnerCodeStateService.enabled !== null && !this.partnerCodeStateService.enabled) {
      this.connectionService.setAuthorizationToken(token, true);
    }
    if (!token) {
      this.router.navigate(['maintenance']);
    } else {
      if (this.router.url === '/maintenance') {
        this.router.navigate(['']);
      }
    }
  }

  private _sendEventCard(card: ScanCard): void {
    if (!card || !this._isNewScanCard(card)) {
      return;
    }
    this.scanCardCodeEvent.next(card);
  }

  private _isNewScanCard(card: ScanCard): boolean {
    if (!card || this._lastScanCard && this._lastScanCard.scanTime.getTime() === card.scanTime.getTime()) {
      return false;
    }
    this._updateLastScanCard(card);
    return true;
  }

  private _updateLastScanCard(card: ScanCard): void {
    this._lastScanCard = card;
  }
}
